/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Folder } from '../../models/folder';
import { UpdateFolderDto } from '../../models/update-folder-dto';

export interface FolderControllerUpdate$Params {
  folderId: string;
      body: UpdateFolderDto
}

export function folderControllerUpdate(http: HttpClient, rootUrl: string, params: FolderControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Folder>> {
  const rb = new RequestBuilder(rootUrl, folderControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('folderId', params.folderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Folder>;
    })
  );
}

folderControllerUpdate.PATH = '/folder/{folderId}';
